import { Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../../../core/services/loader.service';
import { DialogCloseReason } from '../../../layout/dialog/app-dialog.service';
import { Discount } from '../../models/discount.model';
import { DiscountsService } from '../../services/discounts.service';

@Component({
  selector: 'app-discount-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.css'],
  imports: [BoDialogComponent, ButtonComponent],
})
export class DiscountDeleteComponent implements OnInit, OnDestroy {
  private dialogRef = inject<BrnDialogRef<DialogCloseReason>>(BrnDialogRef);
  private discountsService = inject(DiscountsService);
  private loader = inject(LoaderService);

  readonly id = input.required<number | string>();

  public data: Discount;
  private subscriptions: Array<Subscription>;

  constructor() {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  ngOnInit(): void {
    let id = this.id();
    if (typeof id === 'string') {
      id = parseInt(id);
    }
    if (typeof id === 'number') {
      const g$ = this.loader.track(this.discountsService.get$(id)).subscribe({
        next: response => {
          this.data = response.data;
        },
        error: err => {
          console.log(err);
        },
      });
      this.subscriptions.push(g$);
    }
  }

  public onDismiss(reason: DialogCloseReason) {
    this.dialogRef.close(reason);
  }

  public onConfirm(id: number) {
    const d$ = this.discountsService.delete$(id).subscribe({
      next: () => {
        this.onDismiss('success');
      },
      error: err => {
        console.log(err);
      },
    });
    this.subscriptions.push(d$);
  }
}
